<template>
  <div class="user-operation__register">
    <h1 class="user-operation__title">
      <span>注册</span>
    </h1>
    <el-form label-width="0" :model="registerFormModel" :rules="rules" class="user-operation__register-form"
             ref="registerForm">
      <el-form-item prop="cellphone" ref="cellphone">
        <el-input type="tel" placeholder="请输入手机号" v-model="registerFormModel.cellphone" :maxlength="11"
                  @change="allowSendingVerifyCode" @blur="inputBlurFn('cellphone')"></el-input>
      </el-form-item>
      <el-form-item prop="registerPassword" ref="registerPassword">
        <el-input type="password" placeholder="请输入密码" v-model="registerFormModel.registerPassword" :maxlength="16"
                  @change="allowSendingVerifyCode" @blur="inputBlurFn('registerPassword')"></el-input>
      </el-form-item>
      <el-form-item prop="confirmRegisterPassword" ref="confirmRegisterPassword">
        <el-input type="password" placeholder="请再次输入密码" v-model="registerFormModel.confirmRegisterPassword"
                  :maxlength="16" @change="allowSendingVerifyCode"
                  @blur="inputBlurFn('confirmRegisterPassword')"></el-input>
      </el-form-item>
      <el-form-item class="user-operation__sms-validate-code" prop="SMSVerificationCode">
        <el-input placeholder="请输入短信验证码" v-model="registerFormModel.SMSVerificationCode"
                  :disabled="isAllowSendingVerifyCode" :maxlength="6"
                  @blur="inputBlurFn('SMSVerificationCode')"></el-input>
        <el-button type="primary" size="mini" class="user-operation__sms-button" :loading="isLoading"
                   :disabled="SMSVerificationCodeBtn.disabled" @click="getSMSVerificationCode">
          {{SMSVerificationCodeBtn.text}}
        </el-button>
      </el-form-item>
      <el-form-item class="margin-bottom-0 text-right">
        <el-radio-group v-model="registerFormModel.userType">
          <el-radio :label="2">企业</el-radio>
          <el-radio :label="1">个人</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item class="margin-bottom-0 text-left" prop="hasReadContract">
        <el-checkbox class="user-operation__has-read-register-contract" v-model="registerFormModel.hasReadContract">
          我已阅读并同意
        </el-checkbox>
        <a class="user-operation__show-register-contract" @click.prev="showRegisterContract">
          《注册须知》</a>
      </el-form-item>
    </el-form>
    <el-button type="primary" :loading="isRegistering" class="user-operation__register-submit"
               @click.enter="submitForm">
      注册
    </el-button>
  </div>
</template>
<script>
  import placeholders from '../../scripts/placeholders';
  import api from '../../vuex/api';
  import { mapGetters, mapActions, mapMutations } from 'vuex';
  import * as types from '../../vuex/types';

  import userApi from '../../api/user'; // 引用用户Api hgwn 3/9

  export default {
    data () {
      const assignValidator = (type, trigger = 'blur', message = '') => Object.assign({
        required: true,
        trigger,
        message
      }, {
        validator: (rules, value, callback, source, options) => {
          this.$store.dispatch(type, {rules, value, callback, source, options});
        }
      });
      return {
        countDown: '',
        isRegistering: false,
        publicKey: '',
        isAllowSendingVerifyCode: true,
        SMSVerificationCodeBtn: {
          disabled: true,
          text: '获取验证码'
        },
        isLoading: false,
        isCounting: false,
        rules: {
          cellphone: [assignValidator(types.VERIFY_CELLPHONE)],
          registerPassword: [assignValidator(types.VERIFY_REGISTER_PASSWORD)],
          confirmRegisterPassword: [{
            required: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (value === '') {
                callback(new Error('请再次输入密码'));
              } else if (value !== this.registerFormModel.registerPassword) {
                callback(new Error('两次输入密码不一致'));
              } else {
                callback();
              }
            }
          }],
          SMSVerificationCode: [{
            required: true,
            trigger: 'blur',
            message: '请填写收到的短信验证码'
          }],
          hasReadContract: [assignValidator(types.VERIFY_MUST_CHECKED, 'change', '必须阅读并同意《注册协议》')]
        },
        registerFormModel: {
          cellphone: '',
          registerPassword: '',
          confirmRegisterPassword: '',
          SMSVerificationCode: '',
          userType: 2,
          hasReadContract: true
        }
      };
    },
    computed: {
      ...mapGetters({
        ajaxBaseUrl: types.GET_AJAX_BASE_URL,
        companyInfo: types.GET_COMPANY_INFO
      })
    },
    created () {
      this.$store.state[1].msgNum == 0;
    },
    methods: {
      ...mapActions({
        getRegisterContract: types.SET_REGISTER_CONTRACT,
        userLogin: types.USER_LOGIN,
        userRegister: types.USER_REGISTER,
        setAlertMessage: types.SET_FAIL_MESSAGE,
        getGenerateRSAPublicKey: types.GET_GENERATE_RSA_PUBLIC_KEY
      }),
      ...mapMutations({
        setRegisterContract: types.SET_CONTRACT_STATE
      }),
      allowSendingVerifyCode (val) {
        if (this.isCounting === false) {
          this.isAllowSendingVerifyCode = val.trim() !== '';
          const phone = this.registerFormModel.cellphone.trim();
          const password = this.registerFormModel.registerPassword.trim();
          const confirmPassword = this.registerFormModel.confirmRegisterPassword.trim();
          if (phone.length == 11 && password.length >= 8 && confirmPassword.length >= 8) {
            this.SMSVerificationCodeBtn = {
              disabled: false,
              text: '获取验证码'
            };
          } else {
            this.SMSVerificationCodeBtn = {
              disabled: true,
              text: '获取验证码'
            };
          }
        }
      },
      getSMSVerificationCode () {
        this.isLoading = true;
        this.$refs.registerForm.validateField('cellphone');

        this.$refs.registerForm.validateField('registerPassword');
        this.$refs.registerForm.validateField('confirmRegisterPassword');
        // 注册与忘记密码的短信验证倒计时不需要共用，需要就将相关操作扔去action，现在这样就直接请求，降低复杂度
//        setTimeout(() => {
//        const error = document.querySelectorAll('.el-form-item__error')[0]
        if (this.$refs.cellphone.validateState !== 'error' && this.$refs.registerPassword.validateState !== 'error' && this.$refs.confirmRegisterPassword.validateState !== 'error') {
          api.getSMSVerificationCode({
            mobile: this.registerFormModel.cellphone,
            isForRegister: true
          }).then((res) => {
            this.isAllowSendingVerifyCode = false;
            const resData = res.data;
            let countDownTime = 60;
            if (Number(resData.code) === 0) {
              this.countDown = setInterval(() => {
                this.isLoading = false;
                this.isCounting = true;
                countDownTime -= 1;
                if (countDownTime !== 0) {
                  this.SMSVerificationCodeBtn = {
                    disabled: true,
                    text: `${countDownTime}秒后获取`
                  };
                } else {
                  this.SMSVerificationCodeBtn = {
                    disabled: false,
                    text: '获取验证码'
                  };
                  clearInterval(this.countDown);
                  this.isCounting = false;
                }
              }, 1000);
            } else {
              this.isLoading = false;
              this.setAlertMessage({
                show: true,
                content: resData.result
              });
            }
          }).catch((error) => {
            if (error) {
              this.isLoading = false;
            } else {
              this.isLoading = false;
            }
          });
        } else {
          this.isLoading = false;
          this.SMSVerificationCodeBtn = {
            disabled: true,
            text: '获取验证码'
          };
        }
//        }, 500)
//        this.isLoading = false
      },
      showRegisterContract () {
        this.setRegisterContract({
          show: true
        });
      },
      submitForm () {
        this.$refs.registerForm.validate((valid) => {
          if (valid) {
            const form = this.registerFormModel;
            this.isRegistering = true;
            const encrypt = new JSEncrypt();
            encrypt.setPublicKey(this.publicKey);
            const _registerPassword = encodeURI(encrypt.encrypt(form.registerPassword));

            this.userRegister({
              customerLoginName: form.cellphone,
              customerLoginPwd: _registerPassword,
              validCode: form.SMSVerificationCode,
              customerType: form.userType
            }).then((res) => {
              this.isRegistering = false;
              if (Number(res.data.code) === 0) {
                localStorage.setItem('dl_tokenId_bl', res.data.data.token);
                this.$router.push('/personalCenter/myLoan_bl/loanLists_bl');
                location.reload();
              } else {
                if (this.isCounting === false) {
                  this.SMSVerificationCodeBtn.disabled = false;
                  this.SMSVerificationCodeBtn.text = '获取验证码';
                  clearInterval(this.countDown);
                }
              }
            });
          } else {
            setTimeout(() => {
              placeholders.placeHolder(this);
            }, 30);
            return false;
          }
        });
      },
      inputBlurFn (prop) {
        if (event.srcElement) {
          this.registerFormModel[prop] = event.srcElement.value;
        }
      }
    },
    mounted () {
      this.getRegisterContract();
      this.getGenerateRSAPublicKey().then((res) => {
        this.publicKey = res.data.publicKey;
      });
    }
  };
</script>
<style lang="scss">
  .user-operation__register {
    @include userOperationBlockStyle;
  }

  .user-operation__register-form {
    @include userOperationFormStyle;

    .el-radio__label {
      font-family: 'FZLanTingHei-DB-GBK';
      color: $lighterTrueBlack;
      font-size: 14px;
    }

    .el-form-item__content {
      height: 36px;
    }
  }

  .user-operation__sms-validate-code {
    @include resetBFC;

    .el-input.is-disabled .el-input__inner {
      background: none
    }
  }

  .user-operation__sms-button {
    @include vertical-center;
    right: 0;
    border-color: $lighterWaterBlue;
    /*width: 77px;*/
    height: 23px;
    background: $lighterWaterBlue;
    cursor: pointer;

    &:hover, &:active, &:focus {
      border-color: $lighterWaterBlue;
      background: $lighterWaterBlue;
    }
    &.is-loading {
      @include vertical-center;
    }
  }

  .user-operation__has-read-register-contract {
    font-family: 'FZLanTingHei-DB-GBK';
    font-size: 12px;
  }

  .user-operation__show-register-contract {
    color: #EB662B;
    font-family: 'FZLanTingHei-DB-GBK';
    cursor: pointer;

    & + .el-form-item__error {
      padding-top: 0;
    }
  }

  .user-operation__register-submit {
    margin-top: 34px;
    border: 1px solid $orange;
    width: 100%;
    height: 45px;
    // line-height: 45px;
    // letter-spacing: 18px;
    font-size: 14px;
    background: $orange;

    &:hover, &:focus, &:active {
      border: 1px solid $orange;
      background: $orange;
    }

    & span {
      // margin-right: -18px; // letter spacing fix
    }
  }

  .el-checkbox__input.is-checked .el-checkbox__inner:after {
    -ms-transform: rotate(45deg) scaleY(1);
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #EB662B;
    background: #EB662B;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #EB662B;
    border-color: #EB662B;
}
</style>



// WEBPACK FOOTER //
// Register.vue?75f5f32c